import React from "react";
import { Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";
import { LogOut, FileText, Inbox } from "lucide-react";
import { WaldLogo } from "../../components/site/WaldLogo";
import { useAuth } from "../../context/AuthContext";

export const AdminGuard = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-16 opacity-60 text-sm">Checking session…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export const AdminShell = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };
  const nav = [
    { to: "/admin", label: "Insights", icon: FileText, exact: true },
    { to: "/admin/enquiries", label: "Enquiries", icon: Inbox },
  ];
  return (
    <div className="min-h-screen bg-background flex">
      <aside className="w-60 border-r border-border bg-card/40 hidden md:flex flex-col">
        <div className="p-6 border-b border-border">
          <WaldLogo />
          <div className="eyebrow mt-2">Admin</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((item) => {
            const active = item.exact
              ? location.pathname === item.to
              : location.pathname.startsWith(item.to);
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                data-testid={`admin-nav-${item.label.toLowerCase()}`}
                className={`flex items-center gap-2.5 px-3 py-2 text-sm rounded-sm transition-colors ${
                  active
                    ? "bg-[color:var(--wald-copper)] text-white"
                    : "opacity-80 hover:opacity-100 hover:bg-background"
                }`}
              >
                <Icon size={15} strokeWidth={2} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-border">
          <div className="text-xs opacity-70 mb-3 truncate">{user?.email}</div>
          <button
            onClick={doLogout}
            data-testid="admin-logout"
            className="w-full btn-outline text-xs justify-center"
          >
            <LogOut size={13} strokeWidth={2} /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <div className="md:hidden border-b border-border p-4 flex items-center justify-between">
          <WaldLogo />
          <button onClick={doLogout} className="btn-outline text-xs">
            <LogOut size={12} /> Sign out
          </button>
        </div>
        <div className="p-6 md:p-10">{children}</div>
      </div>
    </div>
  );
};
